var _circle, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyContactsTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.184 43.0449C29.3468 42.8993 114.518 45.4635 114.518 45.4635C114.518 45.4635 116.666 97.5599 116.666 99.2947C116.667 101.029 115.94 103.17 112.802 103.281C108.29 103.405 30.2099 102.776 27.63 102.776C25.0502 102.776 23.9338 101.248 23.8639 99.2947C23.7941 97.3416 23.2528 48.6761 23.3431 46.9808C23.4833 44.349 25.0212 43.1905 27.184 43.0449Z",
    fill: "black",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4337 40.207C68.4337 40.207 108.314 41.3863 110.477 41.5319C112.639 41.6775 114.177 42.836 114.317 45.4678C114.408 47.1631 114.59 94.7427 114.521 96.6957C114.451 98.6487 113.334 100.177 110.755 100.177C108.175 100.177 69.7165 100.668 69.7165 100.668L69.7163 100.661C68.0667 100.673 30.1537 100.966 27.63 100.966C25.0502 100.966 23.9338 99.4379 23.8639 97.4849C23.7941 95.5318 23.2528 46.8663 23.3431 45.171C23.4833 42.5392 25.0212 41.3807 27.184 41.2351C29.1957 41.0997 63.6354 40.5278 68.4388 40.4486L68.4337 40.207Z",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7557_220093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 40,
    width: 92,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4337 40.207C68.4337 40.207 108.314 41.3863 110.477 41.5319C112.639 41.6775 114.177 42.836 114.317 45.4678C114.408 47.1631 114.59 94.7427 114.521 96.6957C114.451 98.6487 113.334 100.177 110.755 100.177C108.175 100.177 69.7165 100.668 69.7165 100.668L69.7163 100.661C68.0667 100.673 30.1537 100.966 27.63 100.966C25.0502 100.966 23.9338 99.4379 23.8639 97.4849C23.7941 95.5318 23.2528 46.8663 23.3431 45.171C23.4833 42.5392 25.0212 41.3807 27.184 41.2351C29.1957 41.0997 63.6354 40.5278 68.4388 40.4486L68.4337 40.207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7557_220093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0967 98.4141L27.8054 99.8041L113.548 98.8388L111.807 40.8799C111.807 40.8799 109.918 40.4013 109.184 40.8799C108.45 41.3585 30.4869 93.8786 30.4869 93.8786L27.0967 98.4141Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3057 38.4107C26.3057 38.4107 63.4542 37.9027 65.5119 37.835C67.5696 37.7672 68.737 38.877 68.7732 40.7785C68.8094 42.6799 69.5028 96.142 69.5028 96.142C69.5028 96.142 66.9598 96.1898 65.9952 98.0813C64.4268 98.0382 27.1474 98.4227 27.1474 98.4227L26.3057 38.4107Z",
    fill: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7557_220093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 37,
    width: 44,
    height: 62
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3057 38.4107C26.3057 38.4107 63.4542 37.9027 65.5119 37.835C67.5696 37.7672 68.737 38.877 68.7732 40.7785C68.8094 42.6799 69.5028 96.142 69.5028 96.142C69.5028 96.142 66.9598 96.1898 65.9952 98.0813C64.4268 98.0382 27.1474 98.4227 27.1474 98.4227L26.3057 38.4107Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7557_220093)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.7207,
    y: 37.6719,
    width: 44.1613,
    height: 60.0884,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7207,
    y: 37.6719,
    width: 44.1613,
    height: 59.3644,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7207,
    y: 37.6719,
    width: 44.1613,
    height: 58.2785,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.843 37.332C110.843 37.332 73.9408 37.9156 71.8831 37.8478C69.8253 37.7801 68.6579 38.8899 68.6217 40.7913C68.5855 42.6928 69.34 96.1549 69.34 96.1549C69.34 96.1549 71.8831 96.2027 72.8477 98.0942C74.4161 98.0511 111.71 97.3621 111.71 97.3621L110.843 37.332Z",
    fill: "#A7A7A7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7557_220093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 37,
    width: 44,
    height: 62
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.843 37.332C110.843 37.332 73.9408 37.9156 71.8831 37.8478C69.8253 37.7801 68.6579 38.8899 68.6217 40.7913C68.5855 42.6928 69.34 96.1549 69.34 96.1549C69.34 96.1549 71.8831 96.2027 72.8477 98.0942C74.4161 98.0511 111.71 97.3621 111.71 97.3621L110.843 37.332Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7557_220093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.812 36.6094H67.9346L69.2773 97.8054L113.277 96.6742L112.812 36.6094Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.122 36.8555L68.2141 37.1495L68.9607 97.0507L113.122 96.0321V36.8555Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.542 36.6191H66.986L68.9612 95.9646L113.171 94.9757L111.542 36.6191Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.542 36.6191H66.986L68.9612 95.9646L113.171 94.9757L111.542 36.6191Z",
    fill: "url(#paint0_linear_7557_220093)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7557_220093",
    x1: 80.7072,
    y1: 17.7616,
    x2: 143.524,
    y2: 49.6849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0.496433
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContactsTable);
export default __webpack_public_path__ + "static/media/EmptyContactsTable.8741b3f491b66bb7ab7a47197c680c5d.svg";
export { ForwardRef as ReactComponent };